import cx from 'clsx';
import React from 'react';

import { ShouldPreventDefaultForClick } from '@/components/LaunchStrategiesProvider/utils';
import { IconType } from '@/types/common';

import defaultImage from './error.svg';
import styles from './ErrorContainer.module.scss';

interface LinkItem {
  title: string;
  description?: string;
  image?: IconType;
  url?: string;
  target?: string;
  route_link?: string;
}

export interface ErrorContainerPropTypes {
  title: string;
  description: string;
  image: IconType;
  links?: LinkItem[];
  onErrorItemClick?: (args: { title: string; path: string }) => void;
}

const ErrorContainer: React.FC<ErrorContainerPropTypes> = ({
  title,
  description,
  image,
  links = [],
  onErrorItemClick,
}) => {
  const preventDefaultForClick = ShouldPreventDefaultForClick();

  const handleLinkClick = (
    event: React.MouseEvent<HTMLAnchorElement>,
    item: LinkItem
  ) => {
    const { route_link, title } = item;
    if (preventDefaultForClick || !item.url) {
      event.preventDefault();
    }

    onErrorItemClick &&
      onErrorItemClick({
        title,
        path: route_link || '',
      });
  };

  return (
    <div className={styles.containerWrapper} data-testid="error-container">
      <div className={styles.wrapper} data-testid="error-page-wrapper">
        <div className={styles.contentWrapper}>
          <img
            className={styles.image}
            src={image?.source || defaultImage}
            alt={image?.alt}
          />
          <h3 className={styles.title}>{title}</h3>
          <p
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />

          {links.length === 0 ? null : links.length < 4 ? (
            <div className={styles.buttonsWrapper}>
              {links.map((link, i) => (
                <a
                  className={styles.button}
                  key={i}
                  onClick={e => handleLinkClick(e, link)}
                  href={link.route_link ? link.route_link : link.url || ''}
                  target={link.target || ''}
                >
                  {link.title}
                </a>
              ))}
            </div>
          ) : (
            <div className={styles.moreButtonsWrapper}>
              {links.map((link, i) => (
                <a
                  className={styles.moreButton}
                  key={i}
                  onClick={e => handleLinkClick(e, link)}
                  href={link.route_link ? link.route_link : link.url || ''}
                  target={link.target || ''}
                >
                  <img
                    className={styles.linkImage}
                    alt={link.image ? link.image.alt : ''}
                    src={link.image ? link.image.source : ''}
                  />
                  <div className={cx(styles.linkInfo, styles.textOneLine)}>
                    {link.description ? (
                      <p className={cx(styles.linkSupport, styles.textOneLine)}>
                        {link.description}
                      </p>
                    ) : null}
                    <h3 className={cx(styles.linkMain, styles.textOneLine)}>
                      {link.title}
                    </h3>
                  </div>
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorContainer;
